import { DataSourceMode } from "@mcleod/components";
import { AutogenLayoutCarrierOfferSearch } from "./autogen/AutogenLayoutCarrierOfferSearch";

export class CarrierOfferSearch extends AutogenLayoutCarrierOfferSearch {

    buttonSearchOnClick(event) {
        this.sourceCarrierOffer.search(this.sourceCarrierOffer.getDataboundValues(DataSourceMode.SEARCH));
    }
}
